// react
import React, { Fragment, useState, useEffect } from "react";
import { createPortal } from "react-dom";
// store
import { activityService } from "../../store/services/ServiceActivity";
import { setSelectOptions } from "../../store/services/helpers/functions";
// components
import Navbar from "../../components/general/Navbar";
import InfoCard from "./InfoCard";
import AsyncSelect from 'react-select/async';
// import SearchBar from "./SearchBar"; - may use later
import { Slider } from "react-semantic-ui-range";
import { Modal, Button, Icon, Form, Divider } from "semantic-ui-react";
import { DateInput, TimeInput } from "semantic-ui-calendar-react";
import MobileDateTimePicker from "./MobileDateTimePicker";
import CategoryPicker from "./CategoryPicker";

// others
import moment from "moment";
import "moment/min/locales.min";
moment.locale("sk");


// component
function SearchMapOverlay(props) {
    // state
    const [activities, setActivities] = useState([]);
    const [sliderValue, setSliderValue] = useState(props.config.distance);
    const [isMobile, setIsMobile] = useState(typeof window !== "undefined" && window.innerWidth <= 768);
    const [bannerDismissed, setBannerDismissed] = useState(false);

    useEffect(() => {
        const onResize = () => setIsMobile(window.innerWidth <= 768);
        window.addEventListener("resize", onResize);
        return () => window.removeEventListener("resize", onResize);
    }, []);

    useEffect(() => {
        setBannerDismissed(false);
    }, [props.fallbackInfo]);

    const settings = {
        start: props.config.distance,
        min: 100,
        max: 10000,
        step: 100,
        onChange: (value) => {
            props.setDistanceFunc(value);
            setSliderValue(value);
        },
    };

    // fetch data
    useEffect(() => {
        const fetchData = async () => {
            const activities = await activityService.getPublicActivities(
                "?status=true"
            );
            setActivities(activities);
        };

        fetchData();
    }, []);

    /** component functions **/

    const handleChange = (selected) => {
        props.setActivityTypesFunc(selected.map((item) => item.value));
    };

    // set options for dropdown form field
    const activitiesOptions = setSelectOptions(activities);

    const loadActivityList = async (search) => {
        const results = activitiesOptions.filter((item) => item.text.toLowerCase().includes(search.toLowerCase()));
        return results.map((item) => ({ value: item.value, label: item.text }));
    };

    const sharedFields = (
        <>
            <Form.Field widths="equal">
                <label>
                    Max. vzdialenosť:
                    <span style={{ float: "right" }}>
                        {sliderValue >= 1000 ? sliderValue / 1000 + " km" : sliderValue + " m"}
                    </span>
                </label>
                <Slider
                    style={{
                        trackFill: { backgroundColor: "#e03997" },
                        thumb: { width: "20px", height: "20px" },
                    }}
                    settings={settings}
                />
            </Form.Field>

            <Divider />

            {isMobile ? (
                <MobileDateTimePicker
                    date={props.config.date}
                    time={props.config.time}
                    minDate={moment().format("YYYY-MM-DD")}
                    maxDate={moment().add(1, "years").format("YYYY-MM-DD")}
                    onDateChange={props.setDateFunc}
                    onTimeChange={props.setTimeFunc}
                />
            ) : (
                <Form.Group widths="equal">
                    <DateInput
                        required
                        localization="sk"
                        label="Dátum"
                        placeholder="YYYY-MM-DD"
                        dateFormat="YYYY-MM-DD"
                        minDate={moment().format("YYYY-MM-DD")}
                        maxDate={moment().add(1, 'years').format("YYYY-MM-DD")}
                        iconPosition="right"
                        animation="none"
                        value={props.config.date}
                        onChange={(_, data) => props.setDateFunc(data.value)}
                        closable
                        hideMobileKeyboard
                    />
                    <TimeInput
                        required
                        label="Čas"
                        placeholder="HH:MM"
                        timeFormat="24"
                        iconPosition="right"
                        value={props.config.time}
                        onChange={(_, data) => props.setTimeFunc(data.value)}
                        animation="none"
                        closable
                        hideMobileKeyboard
                    />
                </Form.Group>
            )}

            {isMobile ? (
                <div style={{ marginTop: "1.2rem" }}>
                    <CategoryPicker
                        options={activitiesOptions}
                        selected={props.config.activityTypes}
                        onChange={props.setActivityTypesFunc}
                    />
                </div>
            ) : (
                <>
                <label style={{ fontWeight: "bold", fontSize: "0.9rem", display: "block", marginBottom: "0.4rem" }}>Kategórie</label>
                <AsyncSelect
                    className="react-select search-box"
                    isMulti
                    cacheOptions
                    onChange={(selected) => handleChange(selected)}
                    value={activitiesOptions.filter((item) => props.config.activityTypes.includes(item.value)).map((item) => ({ value: item.value, label: item.text }))}
                    defaultOptions={activitiesOptions.map((item) => ({ value: item.value, label: item.text }))}
                    loadOptions={(search) => loadActivityList(search)}
                />
                </>
            )}
        </>
    );

    // template
    return (
        <>
            <div hidden={!props.mapLoaded}>
                <div className="search-bar-block">
                    <Navbar
                        isSearch
                        onSelect={props.autocomplete}
                        searchConfig={props.searchConfig}
                        searching={props.searching}
                        searchMyLocation={props.searchMyLocation}
                        activeFilterCount={props.activeFilterCount}
                        linkBack="/"
                    />

                    {/* <SearchBar
                        onSelect={props.autocomplete}
                        searchConfig={props.searchConfig}
                        searching={props.searching}
                        searchMyLocation={props.searchMyLocation}
                    /> */}
                </div>

                {props.fallbackInfo && !bannerDismissed && (
                    <div
                        style={{
                            position: "fixed",
                            top: isMobile ? "100px" : "110px",
                            left: "50%",
                            transform: "translateX(-50%)",
                            zIndex: 1500,
                            width: isMobile ? "calc(100% - 2rem)" : "auto",
                            maxWidth: isMobile ? "440px" : "calc(100% - 2rem)",
                            display: "flex",
                            alignItems: "center",
                            gap: "0.6rem",
                            background: "#fff",
                            border: "1px solid #f0c6e0",
                            borderLeft: "4px solid #e03997",
                            borderRadius: "12px",
                            padding: "0.7rem 0.9rem",
                            fontSize: "0.85rem",
                            color: "#444",
                            boxShadow: "0 4px 16px rgba(0,0,0,0.15)",
                        }}
                    >
                        <span style={{ display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0, alignSelf: "center" }}>
                            <Icon name="calendar check outline" style={{ color: "#e03997", margin: 0, lineHeight: 1, position: "relative", top: "1px" }} />
                        </span>
                        <span style={{ flex: 1, lineHeight: 1.35, whiteSpace: isMobile ? "normal" : "nowrap" }}>
                            Na zvolený dátum sme nenašli nič — podľa <strong>rovnakých kritérií</strong> zobrazujeme ponuky na <strong>najbližších 7 dní</strong>
                            {props.fallbackInfo.range && props.fallbackInfo.range.length === 2
                                ? ` (${moment(props.fallbackInfo.range[0]).format("D. M.")} – ${moment(props.fallbackInfo.range[1]).format("D. M.")})`
                                : ""}.
                        </span>
                        <Icon
                            name="close"
                            onClick={() => setBannerDismissed(true)}
                            style={{ cursor: "pointer", color: "#aaa", margin: 0, flexShrink: 0, alignSelf: "flex-start" }}
                        />
                    </div>
                )}

                <div className="info-block-wrapper">
                    {props.foundActivities.map((events, idx) => (
                        <Fragment key={props.uuid()}/*key={idx + Math.floor(Math.random() * 100)}*/>
                            {events.length > 0 &&
                                events.map((event) => (
                                    <Fragment key={props.uuid()}/*key={event.id}*/>
                                        {props.selectedMarker.length > 0 ? (
                                            JSON.stringify(props.selectedMarker) ===
                                            JSON.stringify(event.address) && (
                                                <InfoCard
                                                    mapLoaded={props.mapLoaded}
                                                    event={event}
                                                    position={idx}
                                                    selectedMarker={
                                                        props.selectedMarker
                                                    }
                                                    usersPosition={
                                                        props.usersPosition
                                                    }
                                                />
                                            )
                                        ) : (
                                            <InfoCard
                                                mapLoaded={props.mapLoaded}
                                                event={event}
                                                position={idx}
                                                selectedMarker={
                                                    props.selectedMarker
                                                }
                                                usersPosition={
                                                    props.usersPosition
                                                }
                                            />
                                        )}
                                    </Fragment>
                                ))
                            }
                        </Fragment>
                    ))}
                </div>

                {!isMobile && (
                <Modal
                    className="search-configuration"
                    closeIcon={<Icon name="close" onClick={() => props.setLoadConfigSettings(false)} style={{ paddingTop: "0.3rem" }} />}
                    centered={false}
                    size="tiny"
                    style={{
                        borderRadius: "0",
                        borderBottom: "4px solid #e03997",
                    }}
                    open={props.loadConfigSettings}
                >
                    <Modal.Header style={{ fontSize: "1rem" }}>
                        Upresniť vyhľadávanie
                    </Modal.Header>
                    <Modal.Content>
                        <Form onSubmit={(event) => props.handleSearch(event)}>
                            {sharedFields}

                            <Divider />
                            <Button
                                fluid
                                color="green"
                                style={{ marginLeft: "0", borderRadius: "0" }}
                                onClick={props.searchFunc}
                            >
                                <Icon name="search" /> Uložiť a vyhľadať
                            </Button>
                        </Form>
                    </Modal.Content>
                </Modal>
                )}

                {isMobile && props.loadConfigSettings && createPortal(
                    <div
                        style={{
                            position: "fixed",
                            top: 0,
                            left: 0,
                            right: 0,
                            bottom: 0,
                            background: "#fff",
                            zIndex: 10000,
                            display: "flex",
                            flexDirection: "column",
                            borderTop: "4px solid #e03997",
                        }}
                    >
                        <div
                            style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                                padding: "1rem 1.1rem",
                                borderBottom: "1px solid #eee",
                                flexShrink: 0,
                            }}
                        >
                            <span style={{ fontSize: "1.05rem", fontWeight: "bold" }}>
                                Upresniť vyhľadávanie
                            </span>
                            <Icon
                                name="close"
                                onClick={() => props.setLoadConfigSettings(false)}
                                style={{ cursor: "pointer", margin: 0, fontSize: "1.3rem", color: "#999" }}
                            />
                        </div>

                        <Form
                            onSubmit={(event) => props.handleSearch(event)}
                            style={{ flex: 1, display: "flex", flexDirection: "column", minHeight: 0 }}
                        >
                            <div style={{ flex: 1, overflowY: "auto", padding: "1.1rem" }}>
                                {sharedFields}
                            </div>

                            <div
                                style={{
                                    padding: "0.8rem 1.1rem",
                                    borderTop: "1px solid #eee",
                                    background: "#fff",
                                    flexShrink: 0,
                                }}
                            >
                                <Button
                                    fluid
                                    color="green"
                                    type="submit"
                                    style={{ borderRadius: "10px", padding: "1rem", marginLeft: 0 }}
                                >
                                    <Icon name="search" /> Uložiť a vyhľadať
                                </Button>
                            </div>
                        </Form>
                    </div>,
                    document.body
                )}
            </div>
        </>
    );
}

export default SearchMapOverlay;
